exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".opacity-50[data-v-02bb7e62]{opacity:.5}", ""]);

// exports
